import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const SET_CAMPAIGN_DATES_AS_SLOT_DATES =
  'waitrose/campaigns/SET_CAMPAIGN_DATES_AS_SLOT_DATES';

export const CAMPAIGNS_REQUEST_ACTIONS = apiPromiseTypes('campaigns', 'post');
export const SLOT_DATES_REQUEST_ACTIONS = apiPromiseTypes('slotdates', 'post');
